import { render } from "./AppAddBtn.vue?vue&type=template&id=369ceafc&scoped=true"
import script from "./AppAddBtn.vue?vue&type=script&lang=js"
export * from "./AppAddBtn.vue?vue&type=script&lang=js"

import "./AppAddBtn.vue?vue&type=style&index=0&id=369ceafc&lang=scss&scoped=true"

import exportComponent from "/Users/dmytrokulyk/Documents/Development/GreenHub/dsp-f-2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-369ceafc"]])

export default __exports__